/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonthsEnum } from './monthsEnum';


export interface AirChangeRateUIDTOV0 { 
    airChangeRateMonth?: MonthsEnum;
    airChangeRateValue?: number;
}
export namespace AirChangeRateUIDTOV0 {
}


